import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AuthBroadcastChannelService {

    private readonly broadcastChannel: BroadcastChannel;
    private readonly onMessageReceivedSubject = new Subject<MessageEvent>();

    readonly onMessageReceived$ = this.onMessageReceivedSubject.asObservable();

    constructor() {
        this.broadcastChannel = new BroadcastChannel('auth-channel');
        this.broadcastChannel.onmessage = this.handleBroadcastMessage.bind(this);
    }

    /**
     * Send logout event to other browser tabs.
     */
    postLogout() {
        this.broadcastChannel.postMessage('logout');
    }

    private handleBroadcastMessage(event: MessageEvent) {
        if (event.data === 'logout') {
            this.onMessageReceivedSubject.next(event);
        }
    }
}
